<template>
    <span v-if="formattedValue">{{ formattedValue }}</span>
    <span v-else>&mdash;</span>
</template>

<script>
export default {
    props: ['resourceName', 'field', 'resource'],

    computed: {
        locale() {
            return this.field.locale || 'en'
        },

        currency() {
            return this.field.currency || 'USD'
        },

        formattingOptions() {
            return this.field.formattingOptions || {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }
        },

        formattedValue() {
            const value = this.field.value

            if (value === null || value === undefined || value === '') {
                return null
            }

            try {
                const num = parseFloat(value)
                if (isNaN(num)) return value.toString()

                const formatter = new Intl.NumberFormat(this.locale, {
                    style: 'currency',
                    currency: this.currency,
                    ...this.formattingOptions,
                })

                return formatter.format(num)
            } catch (e) {
                return value.toString()
            }
        },
    },
}
</script>

